import React, { useCallback, useEffect, useState } from 'react';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import useCustomAlert from '../components/Alert2';
import { fbnDownPaymentLink, fbnVerifyDownPayment } from '../services/oxygenRetailServices';
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';
import { updateCustomerOnboardingStat } from '../services/PrequalificationService';
import { QRCodeCanvas } from "qrcode.react"; 

const FBNPaymentLink = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const customAlert = useCustomAlert();
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData?.precustomer);

    const customerPaymentLink = useCallback(async() =>{
        setIsLoading(true);
        // Fetch customer payment link
        const res = await fbnDownPaymentLink(storePrecustomer?.precustomerId);
        console.log("res", res);
        if (res?.status === true) {
            setPaymentData(res?.data);
        }else{
            customAlert.showToast("error", `${res?.message}` || "Failed to fetch payment link");
        }
        setIsLoading(false);
    }, [ storePrecustomer?.precustomerId]);

     useEffect(() =>{
        customerPaymentLink();
     }, [ storePrecustomer?.precustomerId, customerPaymentLink]);

    const handleVerifyPayment = async () =>{
        setLoading(true);
        
        const res = await fbnVerifyDownPayment(storePrecustomer?.precustomerId);
        console.log("res", res);
        if(res?.status === true){
            // Make api call to update the onboarding status
            await updateCustomerOnboardingStat(
                storePrecustomer?.msisdn,
                "KYC_APPROVED"
            );

            dispatch(
                updatePrecustomer({
                    ...storePrecustomer,
                    onboarding_status: "sideload",
                })
            )
            setLoading(false);
            customAlert.showToast("success", `${res?.message}` || "payment verified successfully");
            navigate("/sideload");
            
        }else{
            setLoading(false);
            customAlert.showToast("error", `${res?.message}` || "Failed to verify payment");
        }
    }

  return (
    <PageWrapper>
        <PageTitle title="Customer's Payment Link"/>
            {
                isLoading ? (
                    <div className="mt-5 d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Fetching...</span>
                        </div>
                    </div>
                ):(
                    <>
                    <div className="card-body p-6">
                        <div className="panel panel-primary">
                            <div className="panel-body tabs-menu-body">
                                <div className="tab-content">
                                    <div className="tab-pane active" id="tab2">
                                            <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                                                <div className="py-5">
                                                    <h2 className="page-title">Initial Payment Link</h2>
                                                    <h5 className="py-2">Scan the QR Code to make initial payment or click the Pay Now button</h5>
                                                </div>
                                                <div className="pb-5">
                                                <a
                                                href={paymentData?.data?.authorization_url}
                                                    className="btn btn-primary"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Pay Now
                                                </a>
                                                </div>
                                            </div>
                                        <div style={{ maxWidth: 300 }}>
                                            {paymentData?.base64String && (
                                                <QRCodeCanvas
                                                value={atob(paymentData.base64String)}
                                                size={256}
                                                level="H"
                                                includeMargin={true}
                                                />
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-5 d-grid gap-2">
                        <button
                            onClick={() => handleVerifyPayment()}
                            className="btn btn-primary text-white"
                            disabled={loading}
                        >
                            {loading ? "Please wait..." : "Proceed"}
                        </button>
                    </div>
                    </>
                )
            }
    </PageWrapper>
  )
}

export default FBNPaymentLink;